import { Component, OnInit, OnDestroy, Injectable, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActionCommand, ActionCommandService } from '../../../../services/action-command.service';
import { MenuStateService } from '../../../../services/menu-state.service';
import { PdvService } from '../../pdv.service';
import { ClosePdvDto } from '../../dto/closePdvDto';
import { PrintService } from '../../../../services/print.service';


@Injectable()
@Component({
  selector: 'app-close-shift-work',
  imports: [CommonModule, FormsModule],
  templateUrl: './close-shift-work.component.html'
})
export class CloseShiftWorkComponent implements OnInit, OnDestroy, ActionCommand {
  
  finalCashValue: number = 0;
  observations: string = '';
  
  // Propriedades para cada tipo de pagamento
  moneyTotal: number = 0;
  pixTotal: number = 0;
  creditCardTotal: number = 0;
  debitCardTotal: number = 0;
  checkTotal: number = 0;
  creditTotal: number = 0;
  bankTransferTotal: number = 0;
  voucherTotal: number = 0;
  depositTotal: number = 0;
  cashBackTotal: number = 0;

  constructor(
    private pdvService: PdvService,
    private printService: PrintService,
    @Inject(ActionCommandService) private actionCommandService: ActionCommandService,
    @Inject(MenuStateService) private menuStateService: MenuStateService
  ) {}

  ngOnInit(): void {
    this.registerCommands();
  }

  ngOnDestroy(): void {
    this.unregisterCommands();
  }

  private registerCommands(): void {
    // Registrar comando F1 para fechar turno
    this.actionCommandService.registerCommand({
      getKey: () => 'F1',
      execute: () => this.closeShift(),
      getDescription: () => 'Fechar Turno'
    });

    // Registrar comando ESC para cancelar
    this.actionCommandService.registerCommand({
      getKey: () => 'ESC',
      execute: () => this.cancel(),
      getDescription: () => 'Cancelar'
    });
  }

  private unregisterCommands(): void {
    this.actionCommandService.unregisterCommand('F1');
    this.actionCommandService.unregisterCommand('ESC');
  }

  closeShift(): void {
    if (this.validateForm()) {
      // Aqui você implementaria a lógica para fechar o turno
      console.log('Fechando turno com valor final:', this.finalCashValue);
      console.log('Observações:', this.observations);
      
      // Dados de pagamento por tipo
      const paymentData : ClosePdvDto = {
        money: this.moneyTotal,
        pix: this.pixTotal,
        creditCard: this.creditCardTotal,
        debitCard: this.debitCardTotal,
        check: this.checkTotal,
        credit: this.creditTotal,
        bankTransfer: this.bankTransferTotal,
        voucher: this.voucherTotal,
        deposit: this.depositTotal,
        cashBack: this.cashBackTotal
      };

      const pdvId = Number(localStorage.getItem('pdvId'));
      this.pdvService.close(pdvId, paymentData).subscribe({
        next: () => {
          if (Number.isFinite(pdvId) && pdvId > 0) {
            this.printService.printCashClose(pdvId);
          }
          localStorage.removeItem('pdvId');
          this.menuStateService.closeAdminMenu();
        },
        error: (error) => {
          console.error('Erro ao fechar turno:', error);
        }
      });
      console.log('Dados de pagamento por tipo:', paymentData);
    }
  }

  cancel(): void {
    // Voltar ao menu admin
    this.menuStateService.goBackToMainMenu();
  }

  private validateForm(): boolean {
    if (this.finalCashValue < 0) {
      alert('O valor final do caixa não pode ser negativo');
      return false;
    }
    
    // Validar se pelo menos um tipo de pagamento foi informado
    const hasPaymentData = this.moneyTotal > 0 || this.pixTotal > 0 || this.creditCardTotal > 0 || 
                          this.debitCardTotal > 0 || this.checkTotal > 0 || this.creditTotal > 0 ||
                          this.bankTransferTotal > 0 || this.voucherTotal > 0 || this.depositTotal > 0 ||
                          this.cashBackTotal > 0;
    
    if (!hasPaymentData) {
      alert('É necessário informar pelo menos um tipo de pagamento recebido');
      return false;
    }
    
    return true;
  }

  // Implementação da interface ActionCommand
  getKey(): string {
    return 'F1';
  }

  execute(): void {
    this.closeShift();
  }

  getDescription(): string {
    return 'Fechar Turno';
  }
}